import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';

import LoginModule from '@/modules/login-module';
import LastModule from '@/modules/last-module.vue';
import OnboardingModule from '@/modules/onboarding-module';
import EmployeeModule from '@/modules/employee-module.vue';
import EmployeeReviewModule from '@/modules/employee-review-module.vue';
import ViewManagerModule from '@/modules/view-manager-module';
import ViewManagerEmbeddedModule from '@/modules/view-manager-embedded-module';
import BlockModule from '@/modules/BlockModule';
import BeforePrintEditingModule from '@/modules/before-print-editing-module.vue';
import DocumentDownloadModule from '@/modules/document-download-module.vue';
import DocumentDownloadModuleDms from '@/modules/document-download-module-dms.vue';
import { DOWNLOAD_DOCUMENT_TYPES } from '@/modules/definitions';

const routes = [
  {
    path: '/utils/before-print-editing',
    name: 'before-print-editing',
    component: BeforePrintEditingModule,
    props: true,
  },
  {
    path: '/tenants/:tenantId/employees/:employeeId/signature-documents/:documentId/signed-file;:tempToken',
    name: 'document-download-module-dms',
    component: DocumentDownloadModuleDms,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/docsignatures/:documentId/fields/:fieldId/files;:tempToken',
    name: 'document-download-module',
    component: DocumentDownloadModule,
    props: (route) => ({
      downloadingDocumentType: DOWNLOAD_DOCUMENT_TYPES.DOCSIGN,
      params: route.params,
    }),
  },
  {
    path: '/onboarding/:onboardingId/requested-documents/:documentId/files;:tempToken',
    name: 'form-download-module',
    component: DocumentDownloadModule,
    props: (route) => ({
      downloadingDocumentType: DOWNLOAD_DOCUMENT_TYPES.FORM,
      params: route.params,
    }),
  },
  {
    path: '/onboarding/:onboardingId/document/:slug',
    name: 'document-module',
    component: EmployeeModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/bye',
    name: 'last-module',
    component: LastModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/review',
    name: 'view-module',
    component: EmployeeReviewModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/manager-embedded/:jwt',
    name: 'view-manager-embedded-module',
    component: ViewManagerEmbeddedModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/manager/:jwt',
    name: 'view-manager-module',
    component: ViewManagerModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId/manager/',
    name: 'view-manager-module-blocked',
    component: BlockModule,
    props: true,
  },
  {
    path: '/onboarding/:onboardingId',
    name: 'OnboardingModule',
    component: OnboardingModule,
    props: true,
  },
  {
    path: '/u/:tempToken',
    name: 'login-module',
    component: LoginModule,
    props: true,
  },
  {
    path: '/:tempToken',
    name: 'login-module',
    component: LoginModule,
    props: true,
  },
  {
    path: '/',
    name: 'BlockModule',
    component: BlockModule,
    props: true,
  },
];

const router = new createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  if (to.name === 'dev-module' && process.env.NODE_ENV !== 'production') {
    return next();
  }

  const whitelist = [
    'login-module',
    'BlockModule',
    'OnboardingModule',
    'view-manager-module',
    'view-manager-embedded-module',
    'document-download-module',
    'document-download-module-dms',
    'form-download-module',
  ];

  if (!whitelist.includes(to.name) && !store.getters.session) {
    return next({ name: 'BlockModule' });
  }

  next();
});

export default router;
